<template>
    <section  class="hero-content" style="margin-bottom:5rem;">
       
      <div class="container section-contest section-value-props ">
        <div class="section-data">
          <div class="section-header">
            <!-- <span class="subheading">{{$t('contests.title')}}</span> -->
            <h2 class="heading-secondary">Ready to Learn by Doing?</h2>
            <img src="/assets/why-invrs-icon.png" class="value-icon">
            <p class="value-description">
         Start right now - no payment, no credit card, no pressure.
         </p>
         <p class="value-description">
Once you sign up, you’ll get access to our tools and data, our games and trading competitions, and our community research. 
         </p>
         <p class="value-description">
You can also preview our courses and explore our free library of investing topics.
</p>
         <p class="value-description">
<b>Curious about the full experience?</b>
</p>
         <p class="value-description">
Unlock our expanded toolset with an Investor Pass (1, 14, or 30 days).<br>
         </p>
         <p class="value-description">When you're ready to subscribe we offer two simple tiers:
         
         <ul class="value-description" style="margin-left: 5rem;">
          <li><b>Premium</b> has the full tool and data set for $24.99/month.</li>
         <li>
           <b>Premium Plus</b> has the same tools and data plus unlimited access to the full course catalogue for $59.99/month.
         </li>
         </ul>
            </p>
           <button @click="goToSignup" style="margin-left:auto;margin-right:auto;margin-top:2rem;">
            <span>Sign Up Now &rarr;</span>
          
          </button>
          </div>
       
        <!-- <div class="join-flex" style="flex-direction:column">
          <a href="/courses"> Explore our course library.</a>
        </div> -->
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import { SIGNUP_URL } from "../../config.js";

  export default {
    data() {
      return {
        valueProps: [],
        obsOptionsValueProps: {
          root: null,
          threshold: 0.3,
        },
        obsOptionsSection: {
          root: null,
          threshold: 0.15,
        },
        section: "",
      };
    },
    mounted() {
      /*this.valueProps = document.querySelectorAll(".home-contest .value-box");
      this.section = document.querySelector(".home-contest .section-value-props");
      const valuePropsObserver = new IntersectionObserver(
        this.revealValueProps,
        this.obsOptionsValueProps
      );
      const sectionObserver = new IntersectionObserver(
        this.revealSection,
        this.obsOptionsSection
      );
      valuePropsObserver.observe(this.section);
      sectionObserver.observe(this.section);*/
    },
    methods: {
       goToSignup() {
        window.location.href = SIGNUP_URL;
      },
      revealValueProps(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.valueProps.forEach((v, i) => {
              setTimeout(() => v.classList.remove("hidden"), i * 100);
            });
          }
        });
      },
      revealSection(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.section.classList.remove("hidden");
          }
        });
      },
    },
  };
  </script>
  
<style scoped>

  section {
    padding: 5rem 0;
    

}

.section-hero[data-v-20b9a5ec] {
    position: relative;
    padding: 5rem 0;
    background: linear-gradient(130deg, #fff 0%, #edfff8 70%, #e0f6ed 80%);
 
}

.hero-content {
  transition: all 0.3s ease-in;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom:1.8rem;

   background: linear-gradient(130deg, #fff 0%, #edfff8 70%, #e0f6ed 80%);
 
}


.heading-secondary{
    font-size: 3rem;
    margin-bottom: 2rem;
}


.subheading {
  color: #33cc99;
}



.heading-tertiary {
    font-size: 2.4rem;
    
    margin-bottom: 0.8rem;
}



.heading-description {
  line-height: 3.5rem;
  width: 60%;
 
  margin-bottom: 4.8rem;
}

.section-contest {
  max-width: 180rem;
  transition: all 0.3s ease-in;
}

.section-value-props {
  transition: all 0.3s ease-in;
}

.value-description {
  font-size: 1.8rem;
  line-height: 2.6rem;
}

.value-icon {
  margin-bottom: 1.6rem;
  width: 9.2rem;
  
}

.section-header {
  display: flex;
  flex-direction: column;
  text-align: ;
}

.value-box {
  transition: all 0.3s ease-in;
}

.hidden {
    transform: translateY(4.8rem);
    opacity: 0;
}

/* **************************** */
/* BELOW 496px (mobile) */
/* **************************** */
@media (max-width: 31em) {
    
}
button {
  font-family: inherit;
  cursor: pointer;
  font-weight: 500;
  color: #fff;
  transition: all 0.2s;
  padding: 5px 10px;
  border-radius: 0.8rem;
  background-image: linear-gradient(
    to right,
    rgb(105, 59, 245, 1),
    rgb(105, 59, 245, 0.85),
    rgb(105, 59, 245, 0.7)
  );
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  font-size: 2rem;
}

button:hover {
  box-shadow: 0 0.4rem 3.2rem rgb(105, 59, 245, 0.6);
  transform: scale(1.05);
}

button > svg {
  width: 3.6rem;
  margin-left: 1rem;
  transition: transform 0.3s ease-in-out;
  font-weight: 700;
}

button:hover svg {
  transform: translateX(5px);
}

button:active {
  transform: scale(0.95);
}

/* **************************** */
/* BELOW 1360px (Small desktop/laptop) */
/* **************************** */
@media (max-width: 85em) {
  .hero {
    max-width: 120rem;
  }

  /* .heading-primary {
    font-size: 6rem;
  } */
}

/* **************************** */
/* BELOW 976px (landscape tablets) */
/* **************************** */
@media (max-width: 61em) {
  /* .heading-primary {
    font-size: 5.6rem;
  } */
}

/* **************************** */
/* BELOW 800px (tablet) */
/* **************************** */
@media (max-width: 50em) {
  .hero-content {
    width: 80%;
  }

}

/* **************************** */
/* BELOW 592px (mobile) */
/* **************************** */
@media (max-width: 37em) {
  .heading-primary {
    font-size: 3rem;
  }

  .hero-description {
    width: 100%;
  }
}

/* **************************** */
/* BELOW 496px (mobile) */
/* **************************** */
@media (max-width: 31em) {
  /* .heading-primary {
    font-size: 4.4rem;
  } */

  .hero-content {
    width: 100%;
  }

  button {
    padding: 8px 16px;
  }
}
  .join-flex {
  margin-top: 2.4rem;
  display: flex;
  align-items: center;
}
  </style>
  